import React from 'react';
import { Section, Reveal } from './Section';
const rows = [{
  action: 'Meses mirando información sin animarte',
  cost: 'Seguís sin un primer paso claro'
}, {
  action: 'Dejar toda tu plata sin un plan',
  cost: 'Un gasto inesperado puede golpearte más fuerte'
}, {
  action: 'Seguir consejos sin entenderlos',
  cost: 'Más dudas y decisiones que no sentís propias'
}, {
  action: 'Esperar juntar $500 USD',
  cost: 'Postergás un aprendizaje que podrías empezar hoy'
}];
export function CostOfDelay() {
  return <Section className="border-y border-white/5 bg-ink-900" data-id="element-49" data-mp="28rlddw59ovwl">
      <Reveal data-id="element-50" data-mp="1uuyehntr7vo1">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-51" data-mp="1uvhn2dxil7pe">
          El costo de seguir postergándolo
        </h2>
      </Reveal>

      <Reveal delay={0.08} data-id="element-52" data-mp="3p992xv6fsnta">
        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10" data-id="element-53" data-mp="3p5tkqjhguynn">
          <div className="grid grid-cols-2 border-b border-white/10 bg-ink-850 text-xs font-semibold uppercase tracking-wide text-gray-400 sm:text-sm" data-id="element-54" data-mp="3t8qb4wd8zz25">
            <div className="p-3 sm:p-4" data-id="element-55" data-mp="1p4snc7hleo7h">Lo que hacés hoy</div>
            <div className="border-l border-white/10 p-3 sm:p-4" data-id="element-56" data-mp="1p26bhvno5mjg">Lo que te cuesta</div>
          </div>
          {rows.map((row, index) => <div key={row.action} className={`grid grid-cols-2 text-sm ${index % 2 === 0 ? 'bg-ink-900' : 'bg-ink-950'}`} data-id="element-57" data-mp="1ytsljoo9tfkm" data-mpi={index}>
              <div className="p-3 font-medium text-gray-200 sm:p-4" data-id="element-58" data-mp="1b59efcgyj8u4">{row.action}</div>
              <div className="border-l border-white/10 p-3 text-gray-400 sm:p-4" data-id="element-59" data-mp="166gc8g74f499">{row.cost}</div>
            </div>)}
        </div>
      </Reveal>
    </Section>;
}